var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.112,
    height: 49.111,
    viewBox: "0 0 49.112 49.111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1344",
    "data-name": "Group 1344",
    transform: "translate(-413.066 -196.241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1341",
    "data-name": "Group 1341",
    transform: "translate(413.066 196.241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1340",
    "data-name": "Group 1340"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2502",
    "data-name": "Path 2502",
    d: "M437.622,245.352a24.449,24.449,0,0,1-12.248-3.3l-9.567,3.3,1.967-10.131a24.275,24.275,0,0,1-4.707-14.424,24.556,24.556,0,1,1,24.556,24.555Z",
    transform: "translate(-413.066 -196.241)",
    fill: "#32ba46"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1343",
    "data-name": "Group 1343",
    transform: "translate(421.58 204.754)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1342",
    "data-name": "Group 1342",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2503",
    "data-name": "Path 2503",
    d: "M455.239,223.563a14.833,14.833,0,0,0-11.694,23.978l-.992,5.111,4.822-1.662a14.843,14.843,0,1,0,7.864-27.427Z",
    transform: "translate(-439.197 -222.37)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2504",
    "data-name": "Path 2504",
    d: "M453.073,252.288a15.968,15.968,0,0,1-8-2.154l-6.25,2.154,1.284-6.619a15.861,15.861,0,0,1-3.075-9.424,16.042,16.042,0,1,1,16.042,16.043Zm-7.713-4.777.483.3a13.675,13.675,0,1,0-3.525-3.174l.335.429-.7,3.617Z",
    transform: "translate(-437.031 -220.204)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2505",
    "data-name": "Path 2505",
    d: "M458.512,244.766s.942-1.645,1.709-1.739,1.755-.094,2.021.407,1.457,3.417,1.457,3.417a1.145,1.145,0,0,1-.109.987,9.779,9.779,0,0,1-1.019,1.191.871.871,0,0,0,0,1.035,18.885,18.885,0,0,0,2.257,2.768,12.31,12.31,0,0,0,3.666,2.153.736.736,0,0,0,.565-.172c.219-.219,1.41-1.708,1.41-1.708a.835.835,0,0,1,1.018-.2c.635.29,3.385,1.661,3.385,1.661a.6.6,0,0,1,.322.6,3.875,3.875,0,0,1-.6,2.076,4.788,4.788,0,0,1-3.343,1.641,14.753,14.753,0,0,1-8.212-3.677c-2.241-2.242-4.23-4.514-4.7-6.582S457.933,245.618,458.512,244.766Z",
    transform: "translate(-450.569 -234.888)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.18a65edcc8df1b776955aa92f0eb3eb7.svg";
export { ForwardRef as ReactComponent };